import { combineReducers } from 'redux';
import { UI_ACTION_TYPES } from './actionTypes';

const search = (state = false, action = {}) => {
    switch (action.type) {
        case UI_ACTION_TYPES.SEARCH_OPEN:
            return true;
        case UI_ACTION_TYPES.SEARCH_CLOSE:
            return false;
        default:
            return state;
    }
};

const auth = (state = false, action = {}) => {
    switch (action.type) {
        case UI_ACTION_TYPES.AUTH_OPEN:
            return true;
        case UI_ACTION_TYPES.AUTH_CLOSE:
            return false;
        default:
            return state;
    }
};

const sideMenu = (state = false, action = {}) => {
    switch (action.type) {
        case UI_ACTION_TYPES.MENU_OPEN:
            return true;
        case UI_ACTION_TYPES.MENU_CLOSE:
            return false;
        default:
            return state;
    }
};

const region = (state = { country: '', region: '' }, action = {}) => {
    switch (action.type) {
        case UI_ACTION_TYPES.SET_COUNTRY:
            return { ...state, country: action.country };
        case UI_ACTION_TYPES.SET_REGION:
            return { ...state, region: action.region };
        default:
            return state;
    }
};

export const uiReducer = combineReducers({ search, auth, sideMenu, region });
